<div class="kpi-indicator" [matTooltip]="tooltip">
  <mat-icon [style]="{ color: color }">{{ icon }}</mat-icon>
</div>
